import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';

import { Button } from '../../../Button/Button.tsx';

export const StyledActionsGrid = styled(Grid)`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const StyledButton = styled(Button)`
  font-size: ${({ theme }) => theme.typography.body2.fontSize};
`;

export const StyledCheckboxGrid = styled(Grid)`
  align-items: center;
  display: flex;
  justify-content: center;
`;

export const StyledContainerGrid = styled(Grid)`
  background: ${({ theme }) => theme.palette.background.paper};
  height: ${({ theme }) => theme.spacing(5)};
  padding-inline: ${({ theme }) => theme.spacing(2)};
`;
